import styled from 'styled-components'
export const Tag = styled.li`
  display: inline-block;
  font-size: 12px;
  border-radius: 4px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  margin-right: 5px;
  margin-bottom: 5px;
  color: #1890ff;

  &:hover::before {
    content: attr(title);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    padding: 5px;
    font-size: 12px;
    background-color: #1890ff;
    color: #fff;
    border-radius: 4px;
    z-index: 1;
  }
`
